module.exports = __webpack_public_path__ + "static/media/bgr-two-sm.b8ca01b3.webp";